import find from 'lodash/find';
import React, { FC, useState } from 'react';
import { DropDownMenu } from './DropDownMenu';
import { useTranslation } from 'react-i18next';
import { usePaginationAndSortParams } from '../hooks/usePaginationAndSortParams';

export const SORT_BY_NEWLY_ADDED = [
    { key: 'newlyAddedDateNewToOld', label: 'Added: New to Old' },
    { key: 'newlyAddedDateOldToNew', label: 'Added: Old to New' }
];

const SORT_BY_RELEASE_DATE = [
    { key: 'releaseDateNewToOld', label: 'Release Date: New to Old' },
    { key: 'releaseDateOldToNew', label: 'Release Date: Old to New' }
];

const SORT_BY_PAGES = [
    { key: 'pagesMoreToLess', label: 'Pages: More to Less' },
    { key: 'pagesLessToMore', label: 'Pages: Less To More' }
];

const SORT_BY_DURATION = [
    { key: 'durationLongToShort', label: 'Duration: Long to Short' },
    { key: 'durationShortToLong', label: 'Duration: Short to Long' }
];

const SORT_BY_PRICE = [
    { key: 'priceHighToLow', label: 'Price: High to Low' },
    { key: 'priceLowToHigh', label: 'Price: Low to High' }
];

const SORT_BY_CAMPAIGN_SALES = [
    { key: 'campaignSalesEndDateCloseToFar', label: 'Campaign Sale End: Soon to Late' },
    { key: 'campaignSalesEndDateFarToClose', label: 'Campaign Sale End: Late to Soon' }
];

const SORT_BY_PRODUCT_ORDER = [{ key: 'custom', label: 'Custom Product Order' }];

export const CAMPAIGN_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_PRICE,
    ...SORT_BY_CAMPAIGN_SALES
];

export const LIBX_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_NEWLY_ADDED
];

export const NEWLY_ADDED_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_NEWLY_ADDED
];

export const ORDER_DETAILS_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PRICE
];

export const RESERVE_DETAILS_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PRICE,
    { key: 'reservesPerCopy', label: 'Reserves per Copy' }
];

export const COLLECTION_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_NEWLY_ADDED
];

export const SEARCH_RESULT_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_PRICE,

    { key: 'relevance', label: 'Relevance' }
];

export const CHECKOUT_VIEW_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    ...SORT_BY_PRICE
];

export const BY_GENRE_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION
];

export const LOCAL_COLLECTION_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_PRODUCT_ORDER
];

export const LOCAL_CONTENT_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES
];

export const FOREIGN_LANGUAGE_NEWLY_ADDED_SORT_BY = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    ...SORT_BY_NEWLY_ADDED,
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_PRICE
];

const DEFAULT_SORTING = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'stock', label: 'Copies in your library' },
    { key: 'reserve', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_PRICE
];

export const LIST_SORTING = [
    { key: 'titleAZ', label: 'Title' },
    { key: 'authorAZ', label: 'Author' },
    { key: 'narratorAZ', label: 'Narrator' },
    { key: 'seriesAZ', label: 'Series' },
    { key: 'publisherAZ', label: 'Publisher' },
    { key: 'copyAmount', label: 'Copies in your library' },
    { key: 'overallReserveQueue', label: 'No. of Reserves' },
    ...SORT_BY_RELEASE_DATE,
    ...SORT_BY_PAGES,
    ...SORT_BY_DURATION,
    ...SORT_BY_PRICE
];

export const CAT_MAN_PRODUCT_GROUP_SORTING = [
    { value: 'custom', label: 'Custom Product Order' },
    { value: 'releaseDateNewToOld', label: 'Release Date' },
    { value: 'authorAZ', label: 'Author' },
    { value: 'seriesAZ', label: 'Series' },
    { value: 'featuredNewToOld', label: 'Featured' },
    { value: 'mostPopular', label: 'Most popular' },
    { value: 'newToLibraryNewToOld', label: 'New to library' },
    { value: 'pagesLongToShort', label: 'Pages' },
    { value: 'durationLongToShort', label: 'Duration' }
];

type Props = {
    readonly sorting: ReadonlyArray<{ readonly key: string; readonly label: string }> | undefined;
    readonly excludeSorting?: ReadonlyArray<string>;
    readonly sortBy: string;
};

export const SortByDropDown: FC<Props> = ({ sorting: sortOptions = DEFAULT_SORTING, excludeSorting = [], sortBy }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const { setSortBy } = usePaginationAndSortParams();

    const handleSortChange = (sortKey: string) => {
        setSortBy(sortKey);
        setExpanded(false);
    };

    const currentSortOption = find(sortOptions, { key: sortBy }) || sortOptions[0];

    return (
        <DropDownMenu
            expanded={expanded}
            onToggleClick={setExpanded}
            onClickOutside={setExpanded}
            align={'right'}
            className="dd-a-r fl-right"
            btnInnerClassName="bt-inner"
            arrowClassName="up arrow fl-right"
            label={t(`components.sortByDropdown.${currentSortOption.key}`, { defaultValue: currentSortOption.label })}
            iconCode="sort"
            iconSizeClass="md-upper"
            dataDisplayname="SortByDropdown"
        >
            {sortOptions
                .filter(sortOption => !excludeSorting.includes(sortOption.key))
                .map(sortOption => {
                    const isActive = sortOption.key === currentSortOption.key;
                    return (
                        <li key={sortOption.key}>
                            <a
                                className={isActive ? 'checked' : undefined}
                                onClick={() => handleSortChange(sortOption.key)}
                            >
                                {t(`components.sortByDropdown.${sortOption.key}`, { defaultValue: sortOption.label })}
                                {isActive && <i className="material-icons">check</i>}
                            </a>
                        </li>
                    );
                })}
        </DropDownMenu>
    );
};
